/* IR Wheels: Produktkarten im Kompletträder-Design (Titel aufteilen, Reifen-Badge, Einheit unter dem Preis).
   Funktioniert für Shopify-Standardkarten und die Karten der Filter-App. */
(function () {
  var C = window.IRW_CARDS || {};
  var WHEEL = /wheelforce|yido|concaver|japan racing|advance|pp exclusive|elegance|unicate|damina|corspeed|avus|n1 wheels/i;
  var NOT_WHEEL = /cap|deckel|schraube|mutter|ventil|sensor|rdks|pulver|verdichtung|lackierung/i;
  var TYPES = [
    { card: '.product-card-wrapper', links: '.card__heading a', vendor: '.caption-with-letter-spacing', media: '.card__inner', price: '.card__content .price, .price' },
    { card: '.spf-product-card', links: '.spf-product-card__title a', vendor: '.spf-product-card__vendor', media: '.spf-product-card__inner', price: '.spf-product-card__price-wrapper' }
  ];
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function handle(w, T) {
    w.setAttribute('data-irw', '1');
    var links = w.querySelectorAll(T.links);
    if (!links.length) return;
    var title = txt(links[links.length - 1]);
    var parts = title.split('|').map(function (s) { return s.trim(); });
    var vendor = txt(w.querySelector(T.vendor));
    var unit = '';
    if (parts.length >= 4 && /^set$/i.test(parts[0])) {
      links.forEach(function (a) {
        a.textContent = '';
        var car = document.createElement('span'); car.className = 'irw-k-car'; car.textContent = parts[3];
        var name = document.createElement('span'); name.className = 'irw-k-name'; name.textContent = parts[1];
        a.appendChild(car); a.appendChild(name);
        a.setAttribute('title', title);
      });
      var media = w.querySelector(T.media);
      if (media && parts[2] && !media.querySelector('.irw-k-badge')) {
        var badge = document.createElement('span'); badge.className = 'irw-k-badge'; badge.textContent = 'inkl. ' + parts[2];
        media.appendChild(badge);
      }
      unit = C.setLabel || 'Satzpreis für 4 Räder';
    } else if (WHEEL.test(vendor) && !NOT_WHEEL.test(title)) {
      unit = C.wheelLabel || 'pro Felge';
    }
    if (unit && C.units !== false) {
      var price = w.querySelector(T.price);
      if (price && !w.querySelector('.irw-k-unit')) {
        var u = document.createElement('span'); u.className = 'irw-k-unit'; u.textContent = unit;
        price.insertAdjacentElement('afterend', u);
      }
    }
  }
  function run() {
    TYPES.forEach(function (T) {
      document.querySelectorAll(T.card + ':not([data-irw])').forEach(function (w) { handle(w, T); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();